import BasePolicy from '@/policies/BasePolicy.js';

export default class TimePeriodTemplatePolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view all time period templates');
    }

    view(user, timePeriodTemplate) {
        return user.hasPermissionTo('view a time period template');
    }

    create(user, course) {
        return user.hasPermissionTo('create a time period template');
    }

    update(user, timePeriodTemplate) {
        return user.hasPermissionTo('edit a time period template');
    }

    delete(user, timePeriodTemplate) {
        return user.hasPermissionTo('delete a time period template');
    }

    modify(user, timePeriodTemplate) {
        return this.update(user, timePeriodTemplate) || this.delete(user, timePeriodTemplate);
    }
}
